import CancelIcon from '@mui/icons-material/Cancel';
import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import FormatCurrency from '../../components/FormatNumber/FormatCurrency';
import DefaultModal from '../../components/Modals/DefaultModal';
import { ProjectPaymentType } from '../../enums/projectPaymentType';
import { Project } from '../../models/project';

interface Props {
  modalData: { open: boolean; project?: Project };
  closeModal: () => void;
  confirmModal: (declineReason: string) => void;
}

const DeclineModal = (props: Props): JSX.Element => {
  const [declineReason, setDeclineReason] = useState('');
  return (
    <DefaultModal open={props.modalData.open} handleClose={props.closeModal}>
      <Box
        sx={{ px: 6 }}
        alignItems="center"
        display="flex"
        flexDirection="column"
      >
        <CancelIcon color="error" fontSize="large" />
        <Typography
          variant="h4"
          textAlign="center"
          color="grey.700"
          mb={2}
          mt={4}
        >
          Project Decline
        </Typography>
        <Typography variant="body1" textAlign="center" color="grey.700">
          Please confirm you wish to decline the following Project Request:
        </Typography>
      </Box>
      <Box>
        <Typography
          variant="body1"
          fontWeight="bold"
          textAlign="center"
          color="grey.900"
          mt={1.5}
        >
          {props.modalData.project?.projectTitle}
        </Typography>
        {props.modalData.project?.budget && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="baseline"
            mt={1.5}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              color="grey.900"
            >
              <FormatCurrency value={props.modalData.project?.budget} />
            </Typography>
            <Typography variant="body1" textAlign="center" color="grey.700">
              /{ProjectPaymentType[props.modalData.project?.paymentType]}
            </Typography>
          </Box>
        )}
      </Box>

      <Typography
        variant="body1"
        fontWeight="bold"
        textAlign="center"
        color="grey.900"
        mt={6}
        mb={1.5}
      >
        Please provide a reason to decline this request
      </Typography>

      <TextField
        multiline
        sx={{ padding: '0px 70px' }}
        value={declineReason}
        onChange={(event) => setDeclineReason(event.target.value)}
      />
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={props.closeModal}>
          Close
        </Button>
        <Button
          onClick={() => props.confirmModal(declineReason)}
          disabled={!declineReason}
        >
          Confirm
        </Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default DeclineModal;
